import { loadSystemConfig } from 'redux/actions'
import { put, takeLatest } from 'redux-saga/effects'
import { getType } from 'typesafe-actions'
import { notification } from 'antd'
import { getCurrentDate } from 'shared/utils/getCurrentDate'

function* loadSystemConfigSaga() {
    try {
        /* const lsUser = localStorage.getItem('user')
        const lsSecretKey = localStorage.getItem('secretKey')

        if (lsUser === null || lsSecretKey === null) {
            //throw new Error('Authorization failed')
        } */

        yield put(loadSystemConfig.success({ env: 'dev' }))
    } catch (err) {
        yield put(loadSystemConfig.failure(err))
        notification['error']({
            message: 'Ошибка авторизации 401',
            description: `Неверный LDAP (логин) или пароль. \n Текущее время: ${getCurrentDate()}`,
            duration: 5
        })

        setTimeout(() => {
            if (typeof window !== 'undefined' && window.location.pathname !== '/') {
                window.location.href = '/'
            }
            localStorage.clear()
        }, 5000)
    }
}

export const systemConfigSaga = [
    takeLatest(getType(loadSystemConfig.request), loadSystemConfigSaga)
]
